<template>
  <div>
    <CardApiError
      v-if="apiError"
      :error-text="$t('ADVERTISEMENT.CAMPAIGNS.API_ERROR')"
      @retry="getCampaigns"
    />
    <SearchAdsCampaignsListTable
      v-else
      :is-loading="isLoading"
      :campaigns="campaigns"
    />
  </div>
</template>

<script>
import { SearchAdsCampaigns } from '@/api/api';
import CardApiError from '@@/common/CardApiError';
import SearchAdsCampaignsListTable from './SearchAdsCampaignsListTable';

export default {
  name: 'SearchAdsCampaignsList',
  components: {
    SearchAdsCampaignsListTable,
    CardApiError,
  },
  props: {
    range: {
      type: String,
      required: true,
    },
    updateController: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      campaigns: [],
      apiError: false,
    };
  },
  watch: {
    range(newRange, oldRange) {
      if (oldRange !== newRange) {
        this.getCampaigns();
      }
    },
  },
  created() {
    this.getCampaigns();

    this.updateController.onUpdate(this.getCampaigns);
  },
  beforeDestroy() {
    this.updateController.removeOnUpdate(this.getCampaigns);
  },
  methods: {
    getCampaigns() {
      this.isLoading = true;
      this.apiError = false;
      return SearchAdsCampaigns.getCampaigns(this.range)
        .then(campaigns => {
          this.campaigns = campaigns;
        })
        .catch(({ message }) => {
          this.$message.error(message);

          this.apiError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
